export default "__VITE_ASSET__Cz_t9Hhi__"